import { HighlightText } from "@/components/MedicalChronology/HighlightText";
import { DateInput } from "@/components/ui/DateInput";
import { formatDate } from "@/utils";
import { extractDate } from "@/utils/dateUtils";
import { cn } from "@paribus/shared-ui";
import React from "react";

export interface SummaryPatientFieldProps {
  icon: React.ReactNode;
  label: string;
  value: string | null | undefined;
  isEditMode: boolean;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: "text" | "date";
  highlightQuery: string;
}

export const SummaryPatientField: React.FC<SummaryPatientFieldProps> = ({
  icon,
  label,
  value,
  isEditMode,
  onChange,
  placeholder,
  type = "text",
  highlightQuery,
}) => {
  const displayValue = value?.trim() ? value : null;
  const viewText =
    type === "date" && displayValue
      ? formatDate(extractDate(displayValue) ?? displayValue) || displayValue
      : displayValue;

  return (
    <div className="group flex flex-col gap-1.5">
      <div className="flex items-center gap-1.5">
        <span className="text-neutral-400">{icon}</span>
        <label className="text-2xs font-semibold uppercase tracking-micro text-neutral-500">
          {label}
        </label>
      </div>
      {isEditMode ? (
        type === "date" ? (
          <DateInput
            value={extractDate(value ?? "") ?? ""}
            onChange={onChange}
            className="h-9 w-full cursor-pointer rounded-lg border border-neutral-200 bg-card px-3 pr-10 text-sm font-medium text-neutral-900 shadow-sm transition-all focus-visible:shadow-focus"
          />
        ) : (
          <input
            type="text"
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            className="h-9 w-full rounded-lg border border-neutral-200 bg-card px-3 text-sm font-medium text-neutral-900 shadow-sm transition-all focus-visible:shadow-focus"
            placeholder={placeholder}
          />
        )
      ) : (
        <div className="flex min-h-[36px] items-center">
          <span
            className={cn(
              "text-sm",
              viewText ? "font-semibold text-neutral-900" : "font-medium italic text-neutral-400"
            )}
          >
            {viewText ? (
              <HighlightText text={viewText} highlightQuery={highlightQuery} />
            ) : (
              (placeholder ?? "—")
            )}
          </span>
        </div>
      )}
    </div>
  );
};
